import { ConfigType } from 'dayjs';
import { Box, CloseIcon, IconButton, Paper } from '@methanesat/ui-components';
import { StacTimeSelectorData } from '../../types';
import { TargetSummaryLayout } from '../TargetSummaryLayout';

export const FloatingTargetSummary = ({
    data,
    emissions,
    emissionsTitle,
    overTimeTitle,
    title,
    targetOrGroupId,
    selectedValue,
    closeProps
}: {
    data: StacTimeSelectorData;
    emissions: string;
    emissionsTitle: string;
    overTimeTitle: string;
    title: string;
    targetOrGroupId: string;
    selectedValue: ConfigType;
    closeProps: {
        showCloseButton: boolean;
        onClose: () => void;
    };
}) => {
    return (
        <Box
            data-testid="floating-target-summary"
            position="absolute"
            bottom={0}
            right={0}
            sx={(theme) => ({
                marginBottom: theme.spacing(4),
                marginX: theme.spacing(2),
                '@keyframes fadeIn': {
                    from: { opacity: 0 },
                    to: { opacity: 1 }
                },
                maxWidth: '280px', //adjust this when new date picker implemented
                animation: 'fadeIn ease-in 0.25s',
                display: { xs: 'none', sm: 'none', md: 'block' }
            })}
        >
            <Paper
                sx={{
                    padding: 2,
                    maxWidth: 'inherit'
                }}
            >
                <TargetSummaryLayout
                    data={data}
                    emissions={emissions}
                    emissionsTitle={emissionsTitle}
                    title={title}
                    targetOrGroupId={targetOrGroupId}
                    overTimeTitle={overTimeTitle}
                    selectedValue={selectedValue}
                />
            </Paper>
            {closeProps.showCloseButton && (
                <IconButton
                    data-testid="close-floating-summary-button"
                    onClick={closeProps.onClose}
                    sx={(theme) => ({
                        color: theme.palette.text.primary,
                        position: 'absolute',
                        top: theme.spacing(1),
                        right: theme.spacing(1),
                        zIndex: 1000
                    })}
                >
                    <CloseIcon sx={{ fontSize: '1.35rem' }} />
                </IconButton>
            )}
        </Box>
    );
};
